const hoverintent = require("hoverintent");

(function () {
  const menu = document.getElementById("main-menu");
  if (!menu) return;

  const body = document.body;
  const itemsHasChildren = menu.querySelectorAll(".menu-item-has-children");

  for (const li of itemsHasChildren) {
    const link = li.querySelector("a");
    const subMenu = li.querySelector(".sub-menu");
    if (!link || !subMenu) continue;

    subMenu.dataset.title = link.textContent.trim();
  }

  if (window.innerWidth < 1000) return;

  const adjustSubmenuPosition = (li) => {
    const subMenu = li.querySelector(".sub-menu");
    if (!subMenu) return;

    subMenu.dataset.flip = "";

    const rect = subMenu.getBoundingClientRect();
    const overflowRight = rect.right > window.innerWidth;

    if (!overflowRight) return;

    // mark submenu as flipped to keep it inside viewport
    subMenu.dataset.flip = "true";
  };

  for (const li of itemsHasChildren) {
    hoverintent(
      li,
      () => {
        li.dataset.showSubmenu = "true";
        body.classList.add("sub-menu-showing");
        adjustSubmenuPosition(li);
      },
      () => {
        li.dataset.showSubmenu = "";
        body.classList.remove("sub-menu-showing");
      }
    );
  }
})();
